/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface AccountNamesState {
    firstName?: string;
    lastName?: string;
}

export type AccountNamesAppState = {
    accountNames: AccountNamesState;
};

const initialState: AccountNamesState = {
    firstName: "",
    lastName: "",
};

const reducer = createTypedReducerWithImmer(initialState, {
    "Pages/AccountSettings/UpdateAccountSettings": (
        draft: Draft<AccountNamesState>,
        action: {
            firstName?: string;
            lastName?: string;
        },
    ) => {
        if (typeof action.firstName !== "undefined") {
            draft.firstName = action.firstName;
        }

        if (typeof action.lastName !== "undefined") {
            draft.lastName = action.lastName;
        }
    },
    // on Load, fill in the names of the user in our custom state
    "Pages/AccountSettings/SetInitialValues": (
        draft: Draft<AccountNamesState>,
        action: {
            account: AccountModel;
        },
    ) => {
        draft.firstName = action.account.firstName;
        draft.lastName = action.account.lastName;
    },
});

type AccountNamesReducer = {
    firstName: typeof reducer;
    lastName: typeof reducer;
};

export type CustomUpdateAccountNamesActions = Parameters<AccountNamesReducer[keyof AccountNamesReducer]>[1] | AnyAction;

(reducers as any).accountNames = reducer;
